import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const EmbedRedirect = (props) => {
  const { coinPairId, coinPairName, api_key } = useParams(); // Extract from URL

  useEffect(() => {
    const redirect_url = `https://cryptomarketdarts.com/DashboardCoin/${coinPairId}/${coinPairName}/${api_key}`;

    console.log('fff = ', redirect_url)
    props._api_login_public({
      api_key: api_key,
      redirect_url: redirect_url
    });
  }, [coinPairId, coinPairName, api_key]);

  return (
    <div>
      <div>Redirecting to https://cryptomarketdarts.com</div>
      <div>coinPairId: {coinPairId}</div>
      <div>coinPairName: {coinPairName}</div>
      <div>api_key: {api_key}</div>
    </div>
  );
};

export default EmbedRedirect;
